<template>
  <div>
    <v-result v-if="showBody" :params="param" :type="showType.APP"></v-result>
  </div>
</template>

<script>
  import Result from './Result.vue';
export default {
  name: 'hello',
  data () {
    return {
      param:'',
      showBody:false
    }
  },
  watch:{
    param:function(p){
      this.showBody = true;
    }
  },
  created(){
    var seft = this;
    this.http.get(this.https.getTaoClass+this.$route.query.idx).then(function(response){
      seft.param=response.data.param;
    }).catch(function(error){
      console.error('error');
    });
  },
  components:{
    'v-result':Result
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// Index.vue?436fdbb8